import React, { useState, useEffect } from 'react';

const InputModal = ({ isOpen, onClose, onConfirm, title, placeholder, initialValue = '' }) => {
    const [value, setValue] = useState(initialValue);
    useEffect(() => { if (isOpen) setValue(initialValue); }, [isOpen, initialValue]);
    if (!isOpen) return null;
    return (
        <div className="fixed inset-0 bg-slate-900/50 backdrop-blur-sm z-[80] flex items-center justify-center p-4 animate-fade-in">
            <div className="bg-white dark:bg-slate-800 rounded-2xl shadow-2xl p-6 max-w-sm w-full transform transition-all scale-100 border border-slate-100 dark:border-slate-700">
                <h3 className="text-xl font-bold text-slate-800 dark:text-slate-100 mb-4">{title}</h3>
                <input type="text" value={value} onChange={(e) => setValue(e.target.value)} placeholder={placeholder} className="w-full border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 text-slate-800 dark:text-slate-100 rounded-xl px-4 py-3 mb-6 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none" autoFocus />
                <div className="flex gap-3">
                    <button onClick={onClose} className="flex-1 py-2.5 bg-slate-100 dark:bg-slate-700 text-slate-600 dark:text-slate-300 rounded-xl font-medium hover:bg-slate-200 dark:hover:bg-slate-600 transition-colors">取消</button>
                    <button onClick={() => onConfirm(value)} disabled={!value.trim()} className="flex-1 py-2.5 bg-indigo-600 text-white rounded-xl font-medium hover:bg-indigo-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">確定</button>
                </div>
            </div>
        </div>
    );
};

export default InputModal;
